import '@tarojs/plugin-platform-weapp/dist/runtime'

import { window } from '@tarojs/runtime'
import { createReactApp } from '@tarojs/plugin-framework-react/dist/runtime'
import { initPxTransform } from '@tarojs/taro'

import component from "!!../node_modules/@tarojs/taro-loader/lib/entry-cache.js?name=app!./app.tsx"

import * as React from 'react'
import ReactDOM from 'react-dom'

var config = {"pages":["pages/virtual-list-demo/index"],"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"WeChat","navigationBarTextStyle":"black"}};
window.__taroAppConfig = config
var inst = App(createReactApp(component, React, ReactDOM, config))

initPxTransform({
  designWidth: 750,
  deviceRatio: {"375":2,"640":1.17,"750":1,"828":0.905},
  baseFontSize: 20,
  unitPrecision: undefined,
  targetUnit: undefined
})
